module.exports = __webpack_public_path__ + "static/media/oecanthus_pellucens.5267316b.mp3";